// removed by extract-text-webpack-plugin
module.exports = {"faqCard":"_1XGvd86s","faqTitle":"_1MuJ4IFt"};


//////////////////
// WEBPACK FOOTER
// ./app/faqs/containers/faqs/faqs.styles.scss
// module id = 680
// module chunks = 0